// =============================================================================
// web/shims/react-native-linear-gradient.js — WEB shim.
//
// react-native-linear-gradient is a native view. On web we render a plain RNW
// <View> whose backgroundImage is a CSS linear-gradient built from the same
// colors/start/end props, so every gradient surface (buttons, headers, orbs)
// looks the same in the browser. Native iOS resolves the real package untouched.
// =============================================================================
import React from 'react';
import { View } from 'react-native';

function toDeg(start, end) {
  const s = start || { x: 0, y: 0 };
  const e = end || { x: 0, y: 1 };
  const dx = e.x - s.x;
  const dy = e.y - s.y;
  // CSS gradient angle: 0deg points up; convert vector (dx,dy) where y grows down.
  const angle = (Math.atan2(dx, -dy) * 180) / Math.PI;
  return (angle + 360) % 360;
}

const LinearGradient = React.forwardRef(function LinearGradientShim(props, ref) {
  const { colors = [], start, end, locations, style, children, ...rest } = props || {};

  const stops = colors.map((c, i) => {
    if (locations && locations[i] != null) {
      return `${c} ${Math.round(locations[i] * 100)}%`;
    }
    return c;
  });

  const backgroundImage =
    stops.length > 1 ? `linear-gradient(${toDeg(start, end)}deg, ${stops.join(', ')})` : undefined;

  const bgColor = stops.length === 1 ? colors[0] : undefined;

  return React.createElement(
    View,
    {
      ref,
      style: [style, { backgroundImage, backgroundColor: bgColor }],
      ...rest,
    },
    children
  );
});

export default LinearGradient;
export { LinearGradient };
